:host {
  display: block;
}

.legrandav-bodytext-primary {
  color: rgb(46, 82, 118);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
}
